import { render, staticRenderFns } from "./ApplicantAlertsForm.vue?vue&type=template&id=21f42c90"
import script from "./ApplicantAlertsForm.vue?vue&type=script&lang=js"
export * from "./ApplicantAlertsForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicantAlertsForm.vue?vue&type=style&index=0&id=21f42c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports